<template>
  <div :class="['header-search', { 'show-search': show }]">
    <cnd-icon name="cnd-search" @click.stop="click" />
    <el-select
      ref="headerSearch"
      v-model="search"
      :remote-method="querySearch"
      filterable
      default-first-option
      remote
      placeholder="Search"
      @change="change"
    >
      <el-option
        v-for="item in options"
        :key="item.path"
        :value="item"
        :label="item.item.title.join('>')"
      />
    </el-select>
  </div>
</template>

<script>
import Fuse from 'fuse.js'
import path from 'path'
// import i18n from '@/lang'

export default {
  name: 'HeaderSearch',
  props: {
    allMenu: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      search: '',
      options: [],
      searchPool: [],
      show: false,
      fuse: undefined
    }
  },
  // computed: {
  //   lang () {
  //     return this.$store.getters.language
  //   }
  // },
  watch: {
    // lang () {
    //   this.searchPool = this.generateRoutes(this.allMenu)
    // },
    // routes () {
    //   this.searchPool = this.generateRoutes(this.allMenu)
    // },
    searchPool(list) {
      this.initFuse(list)
    },
    show(value) {
      if (value) {
        document.body.addEventListener('click', this.close)
      } else {
        document.body.removeEventListener('click', this.close)
      }
    }
  },
  mounted() {
    this.searchPool = this.generateRoutes(this.allMenu)
  },
  methods: {
    click() {
      this.show = !this.show
      this.show && this.$refs.headerSearch && this.$refs.headerSearch.focus()
    },
    close() {
      this.$refs.headerSearch && this.$refs.headerSearch.blur()
      this.options = []
      this.show = false
    },
    change(val) {
      this.$router.push(val.item.path)
      this.search = ''
      this.options = []
      this.$nextTick(() => {
        this.show = false
      })
    },
    initFuse(list) {
      this.fuse = new Fuse(list, {
        shouldSort: true,
        threshold: 0.4,
        location: 0,
        distance: 100,
        maxPatternLength: 10,
        minMatchCharLength: 1,
        keys: [{
          name: 'title',
          weight: 0.7
        }, {
          name: 'path',
          weight: 0.3
        }]
      })
    },
    generateRoutes(routes, basePath = '/', prefixTitle = []) {
      let res = []
      for (const router of routes) {
        if (router.hidden) { continue }

        const data = {
          path: path.resolve(basePath, router.path),
          title: [...prefixTitle]
        }

        if (router.meta && router.meta.title) {
          // 标题国际化
          // const hasKey = i18n.te(`route.${router.meta.title}`)
          // let i18nTitle
          // if (hasKey) {
          //   i18nTitle = i18n.t(`route.${router.meta.title}`)
          // } else {
          //   i18nTitle = router.meta.title
          // }
          const i18nTitle = router.meta.title
          data.title = [...data.title, i18nTitle]

          if (router.redirect !== 'noredirect') {
            res.push(data)
          }
        }

        if (router.children) {
          const tempRoutes = this.generateRoutes(router.children, data.path, data.title)
          if (tempRoutes.length >= 1) {
            res = [...res, ...tempRoutes]
          }
        }
      }
      return res
    },
    querySearch(query) {
      query && (this.options = this.fuse.search(query))
      !query && (this.options = [])
    }
  }
}
</script>

